import React from 'react';
import { compose, withHandlers, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';

import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Visibility from '@material-ui/icons/Visibility';
import FormHelperText from '@material-ui/core/FormHelperText';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import { commonStyles } from '../../styles/styles';

const renderProjectCode = ({
  classes,
  meta,
  registrationForm,
  input,
  id,
  showPassword,
  handleClickShowPassword,
  confirmButton,
}) => {
  const conditionError = meta.error && meta.touched;
  return (
    <FormControl
      className={`${classes.formField}
          ${registrationForm ? classes.regField : false}
          ${registrationForm ? classes.fullField : false}`}
      aria-describedby="name-error-text"
      error={conditionError}
    >
      <Typography className={classes.formInputLabel} component="span">
        Program Code
      </Typography>
      <Input
        {...input}
        aria-describedby="name-error-text"
        className={`${classes.formInput} ${conditionError ? classes.inputError : false} ${
          registrationForm ? classes.formInputFocus : ''
        }`}
        disableUnderline
        autoComplete="off"
        error={conditionError}
        id={id}
        classes={{ focused: classes.formInputFocus }}
        type={showPassword ? 'text' : 'password'}
        endAdornment={
          <div className={classes.endWrapper}>
            <InputAdornment position="end">
              <IconButton style={{ color: '#8E8E8E' }} aria-label="Toggle password visibility" onClick={handleClickShowPassword}>
                {!showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
            {confirmButton ? (
              <Button variant="contained" className={classes.defaultButton}>
                CONFIRM
              </Button>
            ) : (
              false
            )}
          </div>
        }
      />
      {conditionError && (
        <FormHelperText id="name-error-password" className={styles.errorBottomText}>
          {meta.error}
        </FormHelperText>
      )}
    </FormControl>
  );
};

const styles = () => ({
  ...commonStyles,
  endWrapper: {
    display: 'flex',
    flexDirection: 'row',
  },
  eye: {
    display: 'inline-flex',
  },
  fullField: {
    width: '100%',
  },
});

export default compose(
  withState('showPassword', 'handleShowPassword', false),
  withHandlers({
    handleClickShowPassword: props => event => {
      event.preventDefault();
      return props.handleShowPassword(!props.showPassword);
    },
  }),
  withStyles(styles),
)(renderProjectCode);
